import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientAdd } from '@classes/client/addClient';
import { ClientPost, ClientSmartHub } from '@classes/client/client';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private http: HttpClient) {}

  getAllClients(filterWithoutLicense = false): Observable<ClientSmartHub[]> {
    return this.http.get<ClientSmartHub[]>(`${environment.apiUrl}/clients`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
      },
      params: {
        filterWithoutLicense: filterWithoutLicense,
      },
    });
  }

  addClient(newClient: ClientAdd) {
    return this.http.post(`${environment.apiUrl}/clients`, newClient, {
      headers: {
        authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
      },
    });
  }
}
